export const NoDataTableMessage: {
  readonly title: string;
  readonly description: string;
} = {
  title: 'No se encontraron resultados',
  description: 'Actualmente no tienes ninguna orden de pago.'
};

export const ErrorTableMessage: {
  readonly title: string;
  readonly description: string;
  readonly textButton: string;
} = {
  title: 'Algo ha salido mal',
  description: 'Hemos tenido un problema en cargar esta pagina. Por favor actualiza la pagina.',
  textButton: 'Actualizar pagina'
};
